export default {
	profiles: '/profiles',
};
